import React, { useEffect, useState } from 'react';
import { Dialog, Form, Input, MessagePlugin, Textarea } from 'tdesign-react';
import { updateVariableStencil } from '@/services/variableService';
import Text from '@/components/Text';

const { FormItem } = Form;

export default function Modal({ visible, handleClose, detail }) {
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();
  const isDefault = detail?.stencilName === 'default';

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      try {
        setSubmitting(true);
        await updateVariableStencil({
          ...detail,
          ...fields,
        });
        MessagePlugin.success('操作成功');
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  useEffect(() => {
    if (visible) {
      form.setFieldsValue(detail);
    } else {
      form.reset();
    }
  }, [visible, form, detail]);

  return (
    <Dialog
      header='基本信息修改'
      visible={visible}
      onClose={() => handleClose()}
      confirmBtn={{ loading: submitting, content: '确定' }}
      onConfirm={() => form.submit()}
      width={550}
    >
      <Form style={{ width: '90%' }} labelWidth={160} form={form} onSubmit={handleSubmit}>
        <FormItem name='stencilName' label='默认值模板名称' rules={[{ required: true }]}>
          {isDefault ? <Text /> : <Input />}
        </FormItem>
        <FormItem name='remark' label='说明'>
          <Textarea placeholder='说明' />
        </FormItem>
      </Form>
    </Dialog>
  );
}
